import { Dispatch } from "redux";
import { MetaData } from "../../models/metaData";
import { metaDataService } from "../../api/index";
import {
  LOAD_META_DATA_SUCCESS,
  LoadMetaDataAction,
  META_DATA_FAILURE,
  META_DATA_REQUEST,
  MetaDataActionTypes,
  MetaDataFailureAction,
  MetaDataRequestAction,
} from "./types";

export function getMetaData() {
  return (dispatch: Dispatch<MetaDataActionTypes>) => {
    dispatch(metaDataRequest());
    metaDataService
      .getMetaData()
      .then((response: MetaData) => {
        dispatch(loadMetaDataSuccess(response));
      })
      .catch(() => {
        dispatch(metaDataFailure());
      });
  };
}

export function loadMetaDataSuccess(data: MetaData): LoadMetaDataAction {
  return {
    type: LOAD_META_DATA_SUCCESS,
    data,
  };
}

export function metaDataRequest(): MetaDataRequestAction {
  return {
    type: META_DATA_REQUEST,
  };
}

export function metaDataFailure(): MetaDataFailureAction {
  return {
    type: META_DATA_FAILURE,
  };
}
